import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=59649a92&scoped=true"
import script from "./AppLink.vue?vue&type=script&lang=ts"
export * from "./AppLink.vue?vue&type=script&lang=ts"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=59649a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59649a92",
  null
  
)

export default component.exports